import React, { useEffect, useRef, useState } from "react";
import { Grid, Modal, CircularProgress, Typography, Button, Dialog, DialogTitle, DialogContent, DialogActions, FormControl, Select, MenuItem, InputLabel } from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { useStyles } from "../../../assets/styles/PatientDashboardStyles";
import strings from "../../../constant/strings";
import HeadingComponent from "../HeadingComponent/index.js";
import {
  HealthParameterList,
  LipidProfileList,
} from "../../../constant/staticLists";
import { useDispatch, useSelector } from "react-redux";
import { Measurements } from "../Measurement";
import { usePatientHealthStyles } from "./style";
import TabComponent from "../../Tab";
import { LipidProfile } from "../LipidProfile";
import { modalStyle, StyledSecondaryButton, } from "../../../assets/styles/CommonStyles";
import { Box } from "@mui/system";
import colors from "../../../constant/colors";
import BloodSugar from "../../Modal/BloodSugar";
import BloodPressure from "../../Modal/BloodPressure";
import BloodOxygen from "../../Modal/BloodOxygen";
import BodyTemperature from "../../Modal/BodyTemperature";
import RespiratoryRate from "../../Modal/RespiratoryRate";
import HeartRate from "../../Modal/HeartRate";
import HealthParameters from "../HealthParameters";
import { useHealthParameterStyles } from "../HealthParameters/style";
import { bloodOxygen, bloodPressure, bloodSugar, bodyTemp, getSleepData, getStepsData, healthParams, heartRate, lipidProfile, patientProfile, respiratoryRate } from "../../../redux/user/userActions";
import LipidProfiles from "../../Modal/LipidProfile";
import moment from "moment";
import { updateProfile } from "../../../services/authService";
import { toast } from "react-toastify";
import EcgScrollImage from "../../EcgScrollImage";
import { getLastEcgApi, getAllECGByDateApi } from "../../../services/mainService.js";

const actionSagaMapping = {
  "bloodPressureData": bloodPressure,
  "bloodSugarData": bloodSugar,
  "spo2sData": bloodOxygen,
  "bodyTemperatureData": bodyTemp,
  "respiratorieData": respiratoryRate,
  "heartRateData": heartRate,
  "heartRateData": heartRate,
  stepsData: getStepsData,
  sleepData: getSleepData
  
}

const tabs = [
  {
    id: 0,
    name: strings.healthParameter,
  },
  {
    id: 1,
    name: strings.lipidProfile,
  },
];

const PatientHealth = () => {
  const commonClasses = useStyles();
  const dispatch = useDispatch();
  const patientHealthClassses = usePatientHealthStyles();
  const useHealthParameterClasses = useHealthParameterStyles();
  const lipidProfileLists = useSelector(state => state.user);
  const [openModal, setOpenModal] = useState(false);
  const [getItemValue, setItemValue] = useState("");
  const [ecgImage, setEcgImage] = useState(null);
  const [loadingEcg, setLoadingEcg] = useState(false);
  const [ecgSpeed, setEcgSpeed] = useState(25);
  const [ecgDisplayDate, setEcgDisplayDate] = useState(null);
  const [ecgImageLoading, setEcgImageLoading] = useState(false);
  const [ecgModalOpen, setEcgModalOpen] = useState(false);
  const [ecgModalDate, setEcgModalDate] = useState(moment().format("YYYY-MM-DD"));
  const [ecgModalList, setEcgModalList] = useState([]);
  const [ecgModalLoading, setEcgModalLoading] = useState(false);
  const [ecgModalPage, setEcgModalPage] = useState(1);
  const [ecgModalTotalPages, setEcgModalTotalPages] = useState(1);
  const [selectedEcgId, setSelectedEcgId] = useState(null);

  console.log('commonClasses____', commonClasses);
  const classes = {
    ...commonClasses,
    ...patientHealthClassses, ...useHealthParameterClasses
  };
  const updatedLipidProfileList = LipidProfileList.map(item => {
    return {
      ...item,
      value: lipidProfileLists[item.value]
    }
  });
  const [tabValue, setTabValue] = React.useState(0);
  const handleTab = (event, newValue) => {
    setTabValue(newValue);
  };
  const { bloodSugar, userData, patientProfileData } = useSelector((state) => ({
    bloodSugar: state.user.bloodSugar,
    userData: state.auth.userData || {},
    patientProfileData: state.user.patientProfile || {},
  }));

  const [duration, setDuration] = React.useState(HealthParameterList.reduce((prev, cur) => {
    prev[cur.primaryKey] = 'w'
    return prev
  }, {}))
  const [date, setDate] = React.useState(HealthParameterList.reduce((prev, cur) => {
    prev[cur.primaryKey] = moment(new Date()).format('YYYY-MM-DD')
    return prev
  }, {}))

  const prevDur = useRef(duration);
  const prevDate = useRef(date);

  console.log('datedatedatedatedate_private::', date);


  useEffect(() => {
    console.log('call1');
    // find the changed dependency and then call its api to fetch data from server as per the details
    let changed
    const preValues = Object.entries(prevDur.current)
    const values = Object.entries(duration)
    preValues.forEach((element, index) => {
      if (element[1] !== values[index][1]) changed = values[index]
    });
    prevDur.current = duration
    if (changed) {
      dispatch(
          actionSagaMapping[changed[0]]({
            token: userData.token,
            duration: changed[1],
            date: date[changed[0]],
          })
        );
    }
  }, [duration])

  useEffect(() => {
    console.log('call______API1');

    // find the changed dependency and then call its api to fetch data from server as per the details
    let changed
    const preValues = Object.entries(prevDate.current)
    const values = Object.entries(date)
    preValues.forEach((element, index) => {
      if (element[1] !== values[index][1]) changed = values[index]
    });
    prevDate.current = date
    if (changed) {
      dispatch(
          actionSagaMapping[changed[0]]({
            token: userData.token,
            duration: duration[changed[0]],
            date: changed[1],
          })
        );
    }
  }, [date])

  const handleClose = () => {
    setOpenModal(false);
  }

  const handleClick = (item) => {
    setOpenModal(true);
    setItemValue(!!item.primaryHeading ? item.primaryHeading : "Lipid Profile")
  }

  const getUpdatedValue = (key, value) => {
    if (value) {
      dispatch(actionSagaMapping[key].call(null, { token: userData.token, duration: duration[key] }))
    }
  }

  useEffect(() => {
    console.log('call______API3');
    // dispatch(bloodSugar({ token: userData.token, duration: 'w' }));
    setTimeout(() => dispatch(heartRate({ token: userData.token, duration: 'w' })), 0);
    console.log('HEALTH___________CALL');
    dispatch(healthParams({ token: userData.token, duration: 'w' }));
    dispatch(lipidProfile({ token: userData.token, duration: 'w' }));

    // Fetch the latest ECG image
    const fetchEcg = async () => {
      try {
        setLoadingEcg(true);
        const res = await getLastEcgApi({ token: userData.token });
        if (res && res.response && res.response.data) {
          setEcgImage(res.response.data.fileUrl || null);
          setEcgSpeed(res.response.data.speed || 25);
          setEcgDisplayDate(res.response.data.timestamp || null);
        }
      } catch (err) {
        console.error("Error fetching ECG:", err);
      } finally {
        setLoadingEcg(false);
      }
    };
    fetchEcg();
  }, [userData])

  const getLipidProfile = (value) => {
    if (value) {
      dispatch(lipidProfile({ token: userData.token, duration: 'w' }));
    }
  }

  const { height, weight, bmi } = React.useMemo(() => {
    const _bmi = patientProfileData.weight && patientProfileData.height ? (patientProfileData.weight / (Math.pow(patientProfileData.height / 100, 2)))?.toFixed(2) || '-' : '-'
    return { height: patientProfileData.height, weight: patientProfileData.weight, bmi: _bmi }
  }, [patientProfileData])

  const handleSubmitForm = async (data) => {
    const response = await updateProfile(data, userData.token)
    if (response.response_type === 'success') {
      toast.success(response?.response?.message, { position: "bottom-center", closeButton: false, autoClose: 2000, style: { width: 'auto', borderRadius: 8 } });
      dispatch(patientProfile({ token: userData.token }))
    } else {
      toast.error(response?.response?.message, { position: "bottom-center", closeButton: false, autoClose: 2000, style: { width: 'auto', borderRadius: 8 } });
    }
  }

  console.log('CORRECT___', classes.mainHealthCont);

  const fetchAllEcg = async (date, page = 1) => {
    try {
      setEcgModalLoading(true);
      const res = await getAllECGByDateApi({
        token: userData.token,
        date,
        page,
        limit: 5,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      });
      if (res && res.response) {
        setEcgModalList(res.response.data?.data || []);
        setEcgModalTotalPages(res.response.data?.pagination?.totalPages || 1);
      }
    } catch (err) {
      console.error("Error fetching ECG by date:", err);
    } finally {
      setEcgModalLoading(false);
    }
  };

  const handleEcgModalClose = () => {
    setEcgModalOpen(false);
    setSelectedEcgId(null);
    setEcgModalDate(moment().format("YYYY-MM-DD"));
    setEcgModalList([]);
    setEcgModalPage(1);
    setEcgModalTotalPages(1);
  };

  return (
    <div>
      <Grid container>
        <Grid item xs={10} className={classes.mainCont}>
          <HeadingComponent
            text={{ primary: strings.health, secondary: strings.homeHeadingText }}
          />
        </Grid>
        <Grid item xs={2} className={classes.mainCont}>
          {/* <StyledSecondaryButton sx={{ textTransform: "capitalize" }}>
            {strings.weeklyAnalysis}
          </StyledSecondaryButton> */}
        </Grid>
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={12} sm={12} md={6} lg={3} >
              <div className={classes.measurementStyle}>
                <Measurements title={strings.weight} keys={"weight"} handleSubmitForm={handleSubmitForm} measurement={weight || '-'} />
              </div>
              <div className={classes.measurementStyle}>
                <Measurements title={strings.height} keys={"height"} handleSubmitForm={handleSubmitForm} measurement={height || '-'} />
              </div>
              <Measurements title={strings.bmi} measurement={bmi || '-'} hide />
            </Grid>
            <Grid item xs={12} sm={12} md={7} lg={8} className={classes.ecgCont} sx={{ position: "relative" }}>
              {loadingEcg || ecgImageLoading ? (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                    minHeight: "250px",
                    bgcolor: "#fff",
                  }}
                >
                  <CircularProgress size={40} />
                </Box>
              ) : ecgImage ? (
                <EcgScrollImage src={ecgImage} />
              ) : (
                <EcgScrollImage />
              )}

              {ecgImage && (
                <Box sx={{
                  position: "absolute", top: 10, left: 10, zIndex: 99,
                  background: "linear-gradient(90deg, #097EB7 0%, #2AAB6C 100%)",
                  borderRadius: "6px",
                  px: 1.4, py: 0.5,
                  display: "flex", alignItems: "center", gap: 0.5,
                  boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
                }}>
                  <Typography sx={{ color: "#fff", fontSize: "12px", fontWeight: 700, letterSpacing: "0.4px" }}>
                    ⚡ {ecgSpeed} mm/s
                  </Typography>
                </Box>
              )}

              {ecgImage && ecgDisplayDate && (
                <Box sx={{
                  position: "absolute", bottom: 12, left: 10, zIndex: 99,
                  bgcolor: "rgba(0,0,0,0.72)",
                  borderRadius: "6px",
                  px: 1.4, py: 0.5,
                  display: "flex", alignItems: "center", gap: 0.5,
                  boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
                  backdropFilter: "blur(3px)",
                }}>
                  <Typography sx={{ color: "#fff", fontSize: "12px", fontWeight: 600, letterSpacing: "0.3px" }}>
                    🕐 {moment.unix(ecgDisplayDate).format("DD MMM YYYY, hh:mm A")}
                  </Typography>
                </Box>
              )}

              {ecgImage && (
                <Box sx={{ position: "absolute", bottom: 12, right: 12, zIndex: 99 }}>
                  <Button
                    onClick={() => setEcgModalOpen(true)}
                    startIcon={<CalendarTodayIcon sx={{ fontSize: 15 }} />}
                    sx={{
                      background: "linear-gradient(90deg, #097EB7 0%, #2AAB6C 100%)",
                      color: "#fff",
                      fontWeight: 600,
                      fontSize: "12px",
                      textTransform: "none",
                      borderRadius: "8px",
                      px: 1.5,
                      py: 0.6,
                      minWidth: "unset",
                      boxShadow: "0 2px 8px rgba(9,126,183,0.4)",
                      "&:hover": {
                        background: "linear-gradient(90deg, #0870a0 0%, #238B5B 100%)",
                        boxShadow: "0 4px 14px rgba(9,126,183,0.6)",
                        transform: "translateY(-1px)",
                      },
                      transition: "all 0.2s ease",
                    }}
                  >
                    ECG History
                  </Button>
                </Box>
              )}
            </Grid>
          </Grid>
        </Grid>
        <Grid container className={classes.marginTop}>
          <Grid item xs={12}>
            <TabComponent {...{ tabs, tabValue, setTabValue, handleTab }} />
          </Grid>
        </Grid>
        {tabValue === 1 ? <Grid container justifyContent={"flex-end"}>
          <Grid item xs={4} className={classes.buttonContainer}>
            <StyledSecondaryButton sx={{ textTransform: "capitalize" }} onClick={handleClick}>
              {strings.addFullLipidProfile}
            </StyledSecondaryButton>
          </Grid>
        </Grid> : null}
        {tabValue === 0 ? (
          <div className={classes.mainHealthCont}>
            <Grid container justify="center" className={classes.secondaryMainHealth}>
              <HealthParameters className={classes} list={HealthParameterList} duration={duration} setDuration={setDuration} handleClick={handleClick} date={date} setDate={setDate} />
            </Grid>
          </div>
        ) : tabValue === 1 ? (
          <Grid container sx={{ display: 'flex' }}>
            <LipidProfile className={classes} list={updatedLipidProfileList} data={bloodSugar} />
          </Grid>
        ) : null}
      </Grid>
      <Modal
        keepMounted
        open={openModal}
        onClose={handleClose}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Box style={modalStyle}>
          {getItemValue === "Blood Sugar" ? <BloodSugar setOpenModal={setOpenModal} getUpdatedValue={getUpdatedValue.bind(this, 'bloodSugarData')} />
            : getItemValue === "Blood Pressure" ? <BloodPressure setOpenModal={setOpenModal} getUpdatedValue={getUpdatedValue.bind(this, 'bloodPressureData')} /> :
              getItemValue === "Blood Oxygen" ? <BloodOxygen setOpenModal={setOpenModal} getUpdatedValue={getUpdatedValue.bind(this, 'spo2sData')} /> :
                getItemValue === "Body Temperature" ? <BodyTemperature setOpenModal={setOpenModal} getUpdatedValue={getUpdatedValue.bind(this, 'bodyTemperatureData')} /> :
                  getItemValue === "Respiratory Rate" ? <RespiratoryRate setOpenModal={setOpenModal} getUpdatedValue={getUpdatedValue.bind(this, 'respiratorieData')} /> :
                    getItemValue === "Lipid Profile" ? <LipidProfiles setOpenModal={setOpenModal} getUpdatedValue={getLipidProfile} /> :
                      <HeartRate setOpenModal={setOpenModal} getUpdatedValue={getUpdatedValue.bind(this, 'heartRateData')} />
          }
        </Box>
      </Modal>

      <Dialog
        open={ecgModalOpen}
        onClose={handleEcgModalClose}
        maxWidth="sm"
        fullWidth
        PaperProps={{ sx: { borderRadius: "16px", p: 1 } }}
      >
        <DialogTitle sx={{
          fontWeight: 700,
          background: "linear-gradient(90deg, #097EB7 0%, #2AAB6C 100%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}>
          Browse ECG by Date
        </DialogTitle>

        <DialogContent>
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 600 }}>Select Date</Typography>
            <input
              type="date"
              value={ecgModalDate}
              max={moment().format("YYYY-MM-DD")}
              onChange={(e) => {
                setEcgModalDate(e.target.value);
                setEcgModalPage(1);
                setEcgModalList([]);
                setSelectedEcgId(null);
              }}
              style={{
                width: "100%",
                padding: "10px 12px",
                borderRadius: "8px",
                border: "1px solid #ccc",
                fontSize: "14px",
                outline: "none",
              }}
            />
            <Button
              variant="contained"
              onClick={() => fetchAllEcg(ecgModalDate, 1)}
              sx={{
                mt: 1.5,
                width: "100%",
                background: "linear-gradient(90deg, #097EB7 0%, #2AAB6C 100%)",
                textTransform: "none",
                fontWeight: 600,
                borderRadius: "8px",
                "&:hover": {
                  background: "linear-gradient(90deg, #0870a0 0%, #238B5B 100%)",
                },
              }}
            >
              Search ECG Records
            </Button>
          </Box>

          {ecgModalLoading ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
              <CircularProgress size={30} sx={{ color: "#097EB7" }} />
            </Box>
          ) : ecgModalList.length === 0 ? (
            <Box sx={{ textAlign: "center", py: 4 }}>
              <Typography color="textSecondary">No ECG records found for this date.</Typography>
            </Box>
          ) : (
            <FormControl fullWidth sx={{ mt: 1 }}>
              <InputLabel>Select ECG Record</InputLabel>
              <Select
                value={selectedEcgId || ""}
                label="Select ECG Record"
                onChange={(e) => setSelectedEcgId(e.target.value)}
                MenuProps={{ PaperProps: { sx: { maxHeight: 260 } } }}
              >
                {ecgModalList.map((ecg) => (
                  <MenuItem key={ecg._id} value={ecg._id}>
                    <Box sx={{ display: "flex", flexDirection: "column", py: 0.5 }}>
                      <Typography variant="body2" sx={{ fontWeight: 600 }}>
                        {moment.unix(ecg.timestamp).format("DD MMM YYYY, hh:mm A")}
                        {ecg.heartRate ? `  •  ${ecg.heartRate} BPM` : ""}
                      </Typography>
                      <Typography variant="caption" sx={{ color: "#888" }}>
                        Device: {ecg.type || "Unknown Device"}
                      </Typography>
                    </Box>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}

          {ecgModalTotalPages > 1 && (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 2, mt: 2 }}>
              <Button
                size="small"
                disabled={ecgModalPage === 1}
                onClick={() => {
                  const prev = ecgModalPage - 1;
                  setEcgModalPage(prev);
                  fetchAllEcg(ecgModalDate, prev);
                }}
                sx={{
                  textTransform: "none",
                  background: "linear-gradient(90deg, #097EB7 0%, #2AAB6C 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  fontWeight: 600,
                }}
              >
                ← Prev
              </Button>
              <Typography variant="body2">{ecgModalPage} / {ecgModalTotalPages}</Typography>
              <Button
                size="small"
                disabled={ecgModalPage === ecgModalTotalPages}
                onClick={() => {
                  const next = ecgModalPage + 1;
                  setEcgModalPage(next);
                  fetchAllEcg(ecgModalDate, next);
                }}
                sx={{
                  textTransform: "none",
                  background: "linear-gradient(90deg, #097EB7 0%, #2AAB6C 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  fontWeight: 600,
                }}
              >
                Next →
              </Button>
            </Box>
          )}
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={handleEcgModalClose} sx={{ textTransform: "none", color: "#888" }}>
            Cancel
          </Button>
          <Button
            variant="contained"
            disabled={!selectedEcgId}
            onClick={() => {
              const selected = ecgModalList.find((e) => e._id === selectedEcgId);
              if (selected?.fileUrl) {
                setEcgModalOpen(false);
                setEcgImageLoading(true);

                setTimeout(() => {
                  setEcgImage(selected.fileUrl);
                  setEcgSpeed(selected.speed || 25);
                  setEcgDisplayDate(selected.timestamp || null);
                  setEcgImageLoading(false);
                }, 800);
              }
              setSelectedEcgId(null);
              setEcgModalDate(moment().format("YYYY-MM-DD"));
              setEcgModalList([]);
              setEcgModalPage(1);
              setEcgModalTotalPages(1);
            }}
            sx={{
              background: "linear-gradient(90deg, #097EB7 0%, #2AAB6C 100%)",
              textTransform: "none",
              fontWeight: 600,
              "&:hover": {
                background: "linear-gradient(90deg, #0870a0 0%, #238B5B 100%)",
              },
            }}
          >
            Show ECG
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default PatientHealth;
